module.exports = __webpack_public_path__ + "static/media/DecorativeLine.764372c3.svg";